// stores/subscriptionStore.js
import { create } from "zustand";
import axiosToken from "../api/axiosClient";
import axios from "axios";

export const useSubscriptionStore = create((set, get) => ({
  // États pour les abonnements
  subscriptions: [],
  currentSubscription: null,
  userSubscriptions: [],
  loading: false,
  error: null,

  // Récupérer tous les abonnements (pour l'admin)
  fetchSubscriptions: async () => {
    set({ loading: true, error: null });
    try {
      const response = await axiosToken.get("/subscriptions");
      let responseData = response.data.data.subscriptions;
      // created_at
      set({
        subscriptions: responseData,
        loading: false,
      });
    } catch (error) {
      set({
        error:
          error.response?.data?.message ||
          "Erreur lors de la récupération des abonnements",
        loading: false,
      });
    }
  },

  // Récupérer les abonnements de l'utilisateur connecté
  fetchUserSubscriptions: async () => {
    set({ loading: true, error: null });
    try {
      const response = await axiosToken.get("/subscriptions/current/user");
      set({
        userSubscriptions: response.data.data.subscriptions,
        loading: false,
      });
    } catch (error) {
      set({
        error:
          error.response?.data?.message ||
          "Erreur lors de la récupération de vos abonnements",
        loading: false,
      });
    }
  },

  // Souscrire à un abonnement
  subscribeToPlan: async (subscriptionData) => {
    set({ loading: true, error: null });
    try {
      const response = await axiosToken.post(
        "/subscriptions",
        subscriptionData,
      );
      const newSubscription = response.data.data;

      // Ajouter à la liste des abonnements utilisateur
      set((state) => ({
        userSubscriptions: [...state.userSubscriptions, newSubscription],
        loading: false,
      }));

      console.log({ newSubscription });

      return newSubscription;
    } catch (error) {
      set({
        error:
          error.response?.data?.message || "Erreur lors de la souscription",
        loading: false,
      });
      throw error;
    }
  },

  subscribeToPlanAnonyme: async (subscriptionData) => {
    set({ loading: true, error: null });
    try {
      const response = await axios.post(
        "/subscriptions/anonymous",
        subscriptionData,
      );
      const newSubscription = response.data.data;
      console.log({ newSubscription });

      // Ajouter à la liste des abonnements utilisateur
      // set((state) => ({
      //   userSubscriptions: [...state.userSubscriptions, newSubscription],
      //   loading: false,
      // }));

      return newSubscription;
    } catch (error) {
      set({
        error:
          error.response?.data?.message || "Erreur lors de la souscription",
        loading: false,
      });
      throw error;
    }
  },

  // Récupérer un abonnement par ID
  fetchSubscriptionById: async (id) => {
    set({ loading: true, error: null });
    try {
      const response = await axiosToken.get(`/subscriptions/${id}`);
      set({
        currentSubscription: response.data.data,
        loading: false,
      });
      return response.data.data;
    } catch (error) {
      set({
        error:
          error.response?.data?.message ||
          "Erreur lors de la récupération de l'abonnement",
        loading: false,
      });
      throw error;
    }
  },

  // Annuler un abonnement
  cancelSubscription: async (id) => {
    set({ loading: true, error: null });
    try {
      await axiosToken.delete(`/subscriptions/${id}`);

      set((state) => ({
        userSubscriptions: state.userSubscriptions.filter(
          (sub) => sub.id !== id,
        ),
        loading: false,
      }));
    } catch (error) {
      set({
        error:
          error.response?.data?.message ||
          "Erreur lors de l'annulation de l'abonnement",
        loading: false,
      });
      throw error;
    }
  },

  // Réinitialiser les erreurs
  clearError: () => set({ error: null }),

  // Réinitialiser l'abonnement courant
  clearCurrentSubscription: () => set({ currentSubscription: null }),
}));
